<template>
  <RevSkeleton v-if="isPending" height="16px" shape="line" width="80px" />

  <span
    v-else
    class="text-static-default-low body-2 block lg:text-caption"
    data-selector="total-products"
    data-test="total-products"
  >
    {{
      i18n(translations.resultsCount, {
        total,
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'

import translations from './ResultsCount.translations'

const i18n = useI18n()

withDefaults(
  defineProps<{
    total?: number
    isPending?: boolean
  }>(),
  {
    total: 0,
  },
)
</script>
